import { MousePointerClick } from 'lucide-react';
import { KeenIcon } from '@/components';
import { ConfirmationModal } from '@/components/modal';
import { useAuthContext } from '@/auth';
import { bulkDeleteAllowed } from './bulkDeleteRules';

const BulkDeleteActions = ({
  canDelete,
  selectedCount,
  bulkDeleteLoading,
  allSelected,
  onOpenConfirm,
  onToggleSelectPage,
  confirmOpen,
  onCloseConfirm,
  onConfirmDelete,
  confirmMessage,
  confirmTitle = 'Are You Sure?',
  confirmBtnText = 'Delete',
  selectAllLabel = 'Select All',
  unselectAllLabel = 'Unselect All',
}) => {
  const { auth } = useAuthContext();

  // The firm can keep bulk delete for admins only (OL-155).
  if (!canDelete || !bulkDeleteAllowed(auth?.user)) return null;

  return (
    <>
      {selectedCount > 0 && (
        <button
          className='text-xs btn btn-sm btn-danger btn-outline'
          onClick={onOpenConfirm}
          disabled={bulkDeleteLoading}
        >
          <KeenIcon icon="trash" className="w-fit btn-icon" />
          {bulkDeleteLoading ? 'Deleting...' : `Delete Selected (${selectedCount})`}
        </button>
      )}
      {/* <button
        className='text-xs btn btn-sm btn-light'
        onClick={onToggleSelectPage}
      >
        <MousePointerClick className="size-4" />
        {allSelected ? unselectAllLabel : selectAllLabel}
      </button> */}

      <ConfirmationModal
        show={confirmOpen}
        onClose={onCloseConfirm}
        onConfirm={onConfirmDelete}
        message={confirmMessage}
        title={confirmTitle}
        btnText={confirmBtnText}
        customBtnClass="btn-danger"
      />
    </>
  );
};

export { BulkDeleteActions };
